import {
  FilesetResolver,
  ImageSegmenter,
  type ImageSegmenterResult,
} from '@mediapipe/tasks-vision';

const LOCAL_WASM_BASE = `${process.env.PUBLIC_URL || ''}/mediapipe/wasm`;
const CDN_WASM_BASE = 'https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision/wasm';
const LOCAL_MODEL = `${process.env.PUBLIC_URL || ''}/models/selfie_segmenter.tflite`;
const CDN_MODEL =
  'https://storage.googleapis.com/mediapipe-models/image_segmenter/selfie_segmenter/float16/1/selfie_segmenter.tflite';

let segmenterPromise: Promise<ImageSegmenter> | null = null;

async function loadWasmFileset() {
  try {
    return await FilesetResolver.forVisionTasks(LOCAL_WASM_BASE);
  } catch (localError) {
    console.warn('Yerel MediaPipe WASM yüklenemedi, CDN deneniyor:', localError);
    return FilesetResolver.forVisionTasks(CDN_WASM_BASE);
  }
}

async function createSegmenterWithModel(
  wasmFileset: Awaited<ReturnType<typeof FilesetResolver.forVisionTasks>>,
  modelPath: string,
  delegate: 'GPU' | 'CPU'
) {
  return ImageSegmenter.createFromOptions(wasmFileset, {
    baseOptions: { modelAssetPath: modelPath, delegate },
    runningMode: 'VIDEO',
    outputConfidenceMasks: true,
    outputCategoryMask: true,
    // Selfie model: daha tutarli kisi maskesi
    displayNamesLocale: 'en',
  });
}

async function createSegmenter(): Promise<ImageSegmenter> {
  const wasmFileset = await loadWasmFileset();
  const modelCandidates = [LOCAL_MODEL, CDN_MODEL];

  for (const modelPath of modelCandidates) {
    for (const delegate of ['GPU', 'CPU'] as const) {
      try {
        const segmenter = await createSegmenterWithModel(wasmFileset, modelPath, delegate);
        console.info(`Kişi tanıma modeli hazır (${delegate}, ${modelPath})`);
        return segmenter;
      } catch (error) {
        console.warn(`Segmenter başlatılamadı (${delegate}, ${modelPath}):`, error);
      }
    }
  }

  throw new Error('Kişi tanıma modeli yüklenemedi');
}

export function getPersonSegmenter(): Promise<ImageSegmenter> {
  if (!segmenterPromise) {
    segmenterPromise = createSegmenter().catch((error) => {
      segmenterPromise = null;
      throw error;
    });
  }
  return segmenterPromise;
}

export function segmentPersonFrame(
  segmenter: ImageSegmenter,
  video: HTMLVideoElement,
  timestampMs: number
): ImageSegmenterResult {
  return segmenter.segmentForVideo(video, timestampMs);
}
